import { useEffect, useState } from "react";
import "./NewsComponent.css";
import PK from "../../../package.json";
import { Button } from "../form/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faCircleInfo, faCheck, faBug, faNewspaper } from "@fortawesome/free-solid-svg-icons";
import { faFaceDizzy } from "@fortawesome/free-solid-svg-icons/faFaceDizzy";

export const NewsComponent = () => {
    const [news, setNews] = useState<{
        title: string;
        description: string;
        news: { value: string }[];
        fixed: { value: string }[];
        bugs: { value: string }[];
        devs: { value: string }[];
    }>({
        title: `Version ${PK.version}`,
        description: "Here are the latest updates and features in this release!",
        news: [
            { value: "News screen added" },
            { value: "Invitation screen added" },
            { value: "Accept invitation screen added" }
        ],
        fixed: [

        ],
        bugs: [
            { value: "Bugs with file uploading with slow connection" },
            { value: "Flashi loading screen" }
        ],
        devs: [
            { value: "Sentry system added" },
            { value: "Google analytics aded" },
            { value: "Google indexing in progress" },
            { value: "Changed some API error codes" },
        ]
    });

    const [displayed, setDisplayed] = useState<boolean>(false);

    const handleClose = () => {
        window.localStorage.setItem("newsDisplayed" + PK.version, "true");
        setDisplayed(true);
    };

    useEffect(() => {
        const alreadyDisplayed = window.localStorage.getItem(
            "newsDisplayed" + PK.version
        );
        setDisplayed(alreadyDisplayed === "true");
    }, []);

    return (
        <>
            {!displayed && (
                <div className="news-modal">
                    <div className="news-mainframe">
                        <header className="news-header">
                            <div>
                                <h1> <FontAwesomeIcon icon={faCircleInfo} className="icon-bullet" /> {news.title}</h1>
                                <p className="news-description">{news.description}</p>
                            </div>
                        </header>

                        {/* Elenco delle novità */}
                        <h3><FontAwesomeIcon icon={faNewspaper} className="icon-bullet" /> New features: </h3>
                        <div className="news-content">
                            <ul>
                                {news.news.map((item, index) => (
                                    <li key={index}>
                                        {item.value}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <h3><FontAwesomeIcon icon={faCheck} className="icon-bullet" /> Bugs fixed: </h3>
                        <div className="news-content">
                            <ul>
                                {news.bugs.map((item, index) => (
                                    <li key={index}>
                                        {item.value}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <h3><FontAwesomeIcon icon={faBug} className="icon-bullet" /> Known bugs: </h3>
                        <div className="news-content">
                            <ul>
                                {news.fixed.map((item, index) => (
                                    <li key={index}>
                                        {item.value}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <h3><FontAwesomeIcon icon={faFaceDizzy} className="icon-bullet" /> Developers news: </h3>
                        <div className="news-content">
                            <ul>
                                {news.devs.map((item, index) => (
                                    <li key={index}>
                                        {item.value}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Pulsante di chiusura */}
                        <footer className="news-footer">
                            <Button
                                action={handleClose}
                                name={<FontAwesomeIcon icon={faX} />}
                                color="red"
                            />
                        </footer>
                    </div>
                </div>
            )}
        </>
    );
};
